import { DeliveryServicesUI } from "./DeliveryServicesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { useSharedServices } from "@/utils/services/useSharedServices";

export function DeliveryServices({
  product,
  configProps,
  flags,
  runtimeConfig,
  experiencesRawObject,
}: Pick<
  StandardProps,
  "product" | "configProps" | "flags" | "runtimeConfig" | "experiencesRawObject"
>) {
  const { variant } = useVariant(product);
  const { services = [] } = variant;
  const { availableServices, actions } = useSharedServices({ product, flags });

  const versionThreePromoDrawer = flags.versionThreePromoDrawer.value;
  const enableServiceQuestionnaireDrawer =
    flags.enableServiceQuestionnaireDrawer.value === true;

  const deliveryServices = services.filter(({ __typename }) =>
    ["DeliveryService"].includes(__typename),
  );

  const hasDeliveryServices = (deliveryServices ?? []).length > 0;

  const deliveryServiceQuestionnaireEnabled =
    Boolean(configProps?.deliveryServiceQuestionnaireEnabled) || false;

  if (!hasDeliveryServices) return null;

  return (
    <DeliveryServicesUI
      availableToOrder={variant?.availability?.availableToOrder || false}
      deliveryServiceQuestionnaireEnabled={deliveryServiceQuestionnaireEnabled}
      showFreeServicePromoTag={!!versionThreePromoDrawer}
      enableServiceQuestionnaireDrawer={enableServiceQuestionnaireDrawer}
      runtimeConfig={runtimeConfig}
      experiencesRawObject={experiencesRawObject}
      availableServices={availableServices}
      actions={actions}
    />
  );
}
